// config.ts

interface Config {
    baseUrl: string;
}

export const BASE_URL = process.env.NEXT_PUBLIC_BACKEND_ADMIN_URL || "" as string;

const config: Config = {
    baseUrl: BASE_URL,
};

export default config;
